import { createContext, useCallback, useContext, useMemo, useState } from "react";

const LoadingContext = createContext({
  count: 0,
  isLoading: false,
  startLoading: () => {},
  stopLoading: () => {},
});

export function LoadingProvider({ children }) {
  const [count, setCount] = useState(0);

  const startLoading = useCallback(() => {
    setCount((c) => c + 1);
  }, []);

  const stopLoading = useCallback(() => {
    setCount((c) => (c > 0 ? c - 1 : 0));
  }, []);

  const value = useMemo(
    () => ({ count, isLoading: count > 0, startLoading, stopLoading }),
    [count, startLoading, stopLoading]
  );

  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
}

export function useLoading() {
  return useContext(LoadingContext);
}
